export const salesColumns = [
  {
    title: '번호',
    dataIndex: 'number',
    key: 'number'
  },
  {
    title: '회원',
    dataIndex: 'customer',
    key: 'customer'
  },
  {
    title: '전화번호',
    dataIndex: 'phonenumber',
    key: 'phonenumber'
  },
  {
    title: '담당자',
    dataIndex: 'trainer',
    key: 'trainer'
  },
  {
    title: '단말기번호',
    dataIndex: 'terminalNumber',
    key: 'terminalNumber'
  },
  {
    title: '거래일시',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: '승인번호',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '거래카드',
    dataIndex: 'cardCompany',
    key: 'cardCompany'
  },
  {
    title: '카드번호',
    dataIndex: 'cardNumber',
    key: 'cardNumber'
  },
  {
    title: '거래금액',
    dataIndex: 'fee',
    key: 'fee'
  },
  {
    title: '상태',
    dataIndex: 'state',
    key: 'state'
  },
  {
    title: '거래유형',
    dataIndex: 'type',
    key: 'type'
  }
];

export const membershipInfoColumns = [
  {
    title: '장비이름',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '멤버십',
    dataIndex: 'membership',
    key: 'membership'
  },
  {
    title: '결제 단말기',
    dataIndex: 'paymentTerminal',
    key: 'paymentTerminal'
  },
  {
    title: '단말기 아이디',
    dataIndex: 'terminalId',
    key: 'terminalId'
  },
  {
    title: '영수증 프린터',
    dataIndex: 'printer',
    key: 'printer'
  },
  {
    title: '사양',
    dataIndex: 'spec',
    key: 'spec'
  },
  {
    title: '로그인 계정',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: '마지막 로그인',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: '관리',
    dataIndex: 'management',
    key: 'management'
  }
];

export const commonSubScribeColumns = [
  {
    dataIndex: 'userInfor',
    key: 'userInfor',
    width: '180px'
  },
  {
    dataIndex: 'contents',
    key: 'contents'
  }
];

export const CardInforcolumns = [
  {
    title: '카드',
    dataIndex: 'card',
    key: 'card'
  },
  {
    title: '번호',
    dataIndex: 'cardNumber',
    key: 'cardNumber'
  },
  {
    title: '관리',
    dataIndex: 'manage',
    key: 'manage'
  }
];

export const MembershipDetailscolumns = [
  {
    title: '멤버십',
    dataIndex: 'membership',
    key: 'membership'
  },
  {
    title: '멤버십 상세',
    dataIndex: 'details',
    key: 'details'
  },
  {
    title: '금액',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: '상태',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '관리',
    dataIndex: 'manage',
    key: 'manage'
  }
];

export const PaymentDetailsListcolumns = [
  {
    title: '결제일',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: '금액',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: '카드번호',
    dataIndex: 'cardNumber',
    key: 'cardNumber'
  },
  {
    title: '결제 건',
    dataIndex: 'paymentCount',
    key: 'paymentCount'
  }
];
